var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin":"20px 10px"}},[_c('van-button',{attrs:{"type":"default","plain":"","block":""},on:{"click":_vm.logout}},[_vm._v("注销")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }